import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BellRing, BellOff, Send } from "lucide-react";
import { toast } from "sonner";
import { getSubscription, permission, pushSupported, needsHomeScreen } from "@/lib/push";
import { HomeScreenHint } from "@/components/CustomerPushPrompt";

export default function StaffPushCard() {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  const link = async (ask) => {
    const sub = await getSubscription(ask);
    if (!sub) return false;
    await api.post("/admin/push/subscribe", sub);
    setOn(true);
    return true;
  };

  useEffect(() => {
    if (pushSupported() && permission() === "granted") link(false).catch(() => {});
  }, []);

  const enable = async () => {
    setBusy(true);
    try {
      const ok = await link(true);
      if (ok) toast.success("Notificações ativadas neste aparelho!");
      else toast.error(permission() === "denied" ? "Notificações bloqueadas. Libere nas configurações do navegador." : "Permissão não concedida.");
    } catch {
      toast.error("Não foi possível ativar as notificações.");
    } finally {
      setBusy(false);
    }
  };

  const test = async () => {
    try {
      const { data } = await api.post("/admin/push/test");
      toast.success(`Teste enviado para ${data.sent} aparelho(s).`);
    } catch {
      toast.error("Falha ao enviar o teste.");
    }
  };

  return (
    <div className="no-print mb-5 bg-[#1C1917] border border-[#292524] rounded-xl p-4 flex flex-col md:flex-row md:items-center gap-3" data-testid="staff-push-card">
      <div className="flex-1">
        <p className="text-sm font-semibold flex items-center gap-2">
          {on ? <BellRing className="w-4 h-4 text-emerald-400" /> : <BellOff className="w-4 h-4 text-stone-400" />}
          <span>{on ? "Notificações de pedidos ativas neste aparelho" : "Ative as notificações de novos pedidos neste aparelho"}</span>
        </p>
        <p className="text-xs text-stone-500 mt-0.5">
          Você recebe um alerta a cada pedido novo e um lembrete por minuto enquanto ele não for aceito, mesmo com o site fechado.
        </p>
        {needsHomeScreen() && <div className="mt-1"><HomeScreenHint dark /></div>}
        {!pushSupported() && !needsHomeScreen() && <p className="text-xs text-amber-400 mt-1">Este navegador não suporta notificações.</p>}
      </div>
      <div className="flex gap-2">
        {!on && pushSupported() && !needsHomeScreen() && (
          <button onClick={enable} disabled={busy} data-testid="staff-push-enable-btn"
            className="inline-flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm font-semibold hover:bg-primary/90 transition-colors disabled:opacity-60">
            <BellRing className="w-4 h-4" /> <span>{busy ? "Ativando..." : "Ativar notificações"}</span>
          </button>
        )}
        {on && (
          <button onClick={test} data-testid="staff-push-test-btn"
            className="inline-flex items-center gap-1.5 rounded-full border border-[#292524] px-4 py-2 text-sm hover:bg-[#292524] transition-colors">
            <Send className="w-4 h-4" /> Enviar teste
          </button>
        )}
      </div>
    </div>
  );
}
